import LinksToPages from "./ui";

export default LinksToPages